import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { VNDialog } from '../../VNCustomerFacingDisplay/components/VNDialog'
import { getCustomerPayingWithCard } from '../Selectors'
import { centsToDollars } from '../../utils/formatters'
import useSpinner from '../../context/hooks/useSpinner'
// import { setCustomerPayingWithCard } from '../ActionCreators'

export const VNCustomerPayingWithCard = () => {
  const dialogOptions = useSelector((state) => getCustomerPayingWithCard(state))
  const isOpen = dialogOptions?.get('open') ?? false
  const { stopSpinner } = useSpinner()
  // const dispatch = useDispatch()

  useEffect(() => {
    if (isOpen) {
      stopSpinner()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  // prevent dialog from rendering if it's not open
  if (!isOpen) {
    return null
  }

  return (
    <VNDialog
      open={isOpen}
      // Next lines are for debugging
      // primaryButtonText={'Cancel'}
      // onPrimaryButtonClick={() => {dispatch(setCustomerPayingWithCard({open: false}))}}
      subTitle={'Customer Paying {{AMOUNT}} with Card'.replace('{{AMOUNT}}', centsToDollars(dialogOptions?.get('amount')))}
    />
  )
}
